<script lang="typescript">
  import { onMount } from "svelte/internal/index";

  export let show:Boolean = false;
  export let hasclose:Boolean = true;
  export let modalname:String;
  export let modaltype:String;
  let modalElement:Object;


  const close = () => {
    // POST: Modal close
    window.postMessage({
        type: 'ModalClosed',
      }, '*'
    );
    show = false;
  };

  const confirm = () => {
    // POST: Modal Name confirm
    window.postMessage({
      type: `${modalname}Confirm`
      }, '*'
    );
    show = false;
  }

  const handleEvent = (e:any):void => {
    // Listen: Modal Name show
    if (e.data.type === `${modalname}`) {
      show = true;
      console.log("true")
    }

    // Listen: Modal close
    if (e.data.type === 'ModalClosed') {
      show = false;
    }
  }

  onMount(() => {
    // LISTEN: Show Modal
    window.addEventListener('message', handleEvent);
    return () => {
      window.removeEventListener('message', handleEvent);
    }
  });
</script>


{#if show}
  <!-- Modal -->
  <div class="modal" bind:this={modalElement}>
    <!-- Modal Content -->
    <div class="modal__content">
      <!-- Modal Close -->
      {#if hasclose === true}
        <span 
          class="modal__close" 
          on:click={close} 
          role="button">
          <slot name="close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </slot>
        </span>
      {/if}
      <!-- Modal Slot content -->
      <slot />
      <!-- Modal confirm section -->
      {#if modaltype === 'confirm'}
        <div class="modal__buttons">
          <!-- Yes -->
          <button
            class="modal__button"
            on:click={confirm}>
            Yes
          </button>
          <!-- No -->
          <button 
            class="modal__button" 
            on:click={close}>
            No
          </button>
        </div>
      {/if}
    </div>
  </div>
{/if}


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    outline: none;
    box-sizing: border-box;
    user-select: var(--retail-text-select, auto);
    font-family: var(--retail-font-family), sans-serif;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: 102;

    &__content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 380px;
      padding: 40px;
      background: #fff;
      font-size: 14px;
      border-radius: 4px;
      
      @media (min-width: 1024px) {
        max-width: 500px;
        font-size: calc(14px * var(--retail-scale-factor));
      }
    }

    &__close {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      right: 0;
      padding: 10px;
      color: var(--retail-secondary-color, #23b04e);
      background: none;
      border: 2px solid var(--retail-secondary-color, #23b04e);
      border-top-right-radius: 4px;
      cursor: pointer;
      transition: all 150ms ease-in-out;

      svg {
        width: 15px;
        height: 15px;
        @media (min-width: 1024px) {
          width: calc(15px * var(--retail-scale-factor));
          height: calc(15px * var(--retail-scale-factor));
        }
      }

      &:hover {
        background: var(--retail-secondary-color, #23b04e);
        color: #fff;
      }
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-top: 40px;
    }

    &__button {
      padding: 8px 20px;
      background: var(--retail-secondary-color, #23b04e);
      color: var(--retail-text-color, #fff);
      border: none;
      border-radius: 4px;
      font-size: 14px;
      @media (min-width: 1024px) {
        padding: 15px 30px;
        font-size: 18px;
      }
    }
  }
</style>
